import { Grid, GridItem, Text } from '@chakra-ui/react'
import type { NewsletterOptInInput } from '@twlvxtwlv/types'
import { useTranslation } from 'next-i18next'

import { NewsletterOptInForm } from '../forms/newsletter-opt-in-form'
import { SectionHeading } from '../../pages/homepage/shared/section-heading'

interface NewsletterOptInProps {
  onSubmit: (newsletterOptInInput: NewsletterOptInInput) => void
}

export function NewsletterOptIn({ onSubmit }: NewsletterOptInProps) {
  const { t } = useTranslation('user-management')

  return (
    <Grid
      id="newsletter"
      templateAreas={[`"header" "form"`, `"header" "form"`, `"header" "form"`, `"header form"`]}
      p={12}
      bg="txtLightGray"
      w="full"
      justifyContent={['center', 'center', 'center', 'normal']}
    >
      <GridItem area="header" alignSelf="flex-start">
        <SectionHeading title={t('newsletter-opt-in-modal-heading')} />
      </GridItem>
      <GridItem area="form">
        <Text fontSize={['md', 'md', 'lg', '2xl']} fontWeight="400">
          {t('newsletter-opt-in-modal-text')}
        </Text>
        <NewsletterOptInForm onSubmit={onSubmit} variant="default" />
      </GridItem>
    </Grid>
  )
}
